const FIGMA_ACTIVITY_TYPE_NAMES = ['社区新闻', '活动信息']

export function normalizeActivityTypes(types = []) {
  const source = Array.isArray(types) ? types : []
  const normalized = source.slice(0, FIGMA_ACTIVITY_TYPE_NAMES.length).map((item, index) => ({
    ...item,
    typeName: FIGMA_ACTIVITY_TYPE_NAMES[index]
  }))

  return normalized
}

export function getActivityTypeName(row = {}) {
  const rawName = row.typeCdName || row.typeName || ''
  const rawCode = row.typeCd || ''
  const lowerName = String(rawName).toLowerCase()
  const lowerCode = String(rawCode).toLowerCase()

  if (rawName === FIGMA_ACTIVITY_TYPE_NAMES[0] || rawName === FIGMA_ACTIVITY_TYPE_NAMES[1]) {
    return rawName
  }

  if (lowerName.includes('新闻') || lowerName.includes('news') || lowerCode.includes('news')) {
    return FIGMA_ACTIVITY_TYPE_NAMES[0]
  }

  if (lowerName.includes('活动') || lowerName.includes('activity') || lowerCode.includes('activity')) {
    return FIGMA_ACTIVITY_TYPE_NAMES[1]
  }

  return rawName || rawCode || '-'
}
